export const ISO_DATE_NO_TZ = 'YYYY-MM-DD HH:mm:ss';
export const TIME_HOUR_MINUTE_SEC_FORMAT = 'HH:mm:ss';

export const HOUR_TO_MILLISECONDS_FACTOR = 3.6 * 10 ** 6;
